<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AsR">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="JANUARY">
<h1 class="chapter1" id="pA4x"><a href="#/contents#AB_ch01" id="AB_cha01">JANUARY</a>
</h1>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter01.vue?d1649c6a